/** @module csi/widget/SvgShapePalette */
define([
	"dojo/_base/declare",
	"dojo/dom-construct",
	"dijit/_PaletteMixin",
	"dijit/_TemplatedMixin",
	"dijit/_Widget",
	"dojo/text!./SvgShapePalette.html",
	"csi/locale",
	"csi/utility/stringUtility",
], function(declare, domConstruct, _PaletteMixin, _TemplatedMixin, _Widget, template, locale, {stringSubstitute}) {

	var _row1Shapes = [
		{icon: "svgIconShapeRect", shapeType: "rect", title: "CanvasRectangle"},
		{icon: "svgIconShapeRoundRect", shapeType: "roundRect", title: "CanvasRoundRectangle"},
		{icon: "svgIconShapeCircle", shapeType: "ellipse", title: "CanvasEllipse"},
		{icon: "svgIconShapeTriangle", shapeType: "triangle", title: "CanvasTriangle"},
		{icon: "svgIconShapePentagon", shapeType: "pentagon", title: "CanvasPentagon"}
	];

	var _row2Shapes = [
		{icon: "svgIconShapeArrow", shapeType: "rightArrow", title: "CanvasArrow"},
		{icon: "svgIconShapeCallout", shapeType: "wedgeRectCallout", title: "CanvasCallout"},
		{icon: "svgIconShapeTickMark", shapeType: "checkMark", title: "CanvasCheckmark"},
		{icon: "svgIconShapeCrossMark", shapeType: "crossmark", title: "CanvasXMark"},
		{icon: "svgIconShapeStar", shapeType: "star5", title: "CanvasStar"}
	];

	return declare([_Widget, _TemplatedMixin, _PaletteMixin], {
		templateString: template,

		createPalette: function() {
			// Create the grid
			this._preparePalette([_row1Shapes, _row2Shapes], []);
			this.initValueByType("rect");
		},

		dyeClass: declare(null, {
			template: "<span class='dijitReset dijitInline dijitIcon csiActionIcon ${iconClass}'></span>",
			shape: null,
			constructor: function(shape, row, col) {
				this.label = shape.icon;
				this.shape = shape;
			},
			getValue: function() {
				return this.shape;
			},
			fillCell: function(cell, blankGif) {
				var html = stringSubstitute(this.template, {
					iconClass: this.shape.icon
				});
				domConstruct.place(html, cell);
				cell.title = locale.resource(this.shape.title);
			}
		}),

		postCreate: function() {
			// Create the grid
			this.createPalette();
			this.inherited(arguments);
		},

		/**
		 * Set selected shape option based on given type
		 * @param {string} type
		 */
		initValueByType: function(type) {
			var shape = _.find(_row1Shapes, {shapeType: type}) || _.find(_row2Shapes, {shapeType: type});
			if (shape) {
				this.set("value", shape, false);
			}
		},

		/**
		 * Get the complete shape object based on the given type
		 * @param {string} type
		 * @return {object} shape for the type
		 */
		getShapeByType: function(type) {
			return _.find(_row1Shapes, {shapeType: type}) || _.find(_row2Shapes, {shapeType: type});
		}
	});
});
